import React from 'react'
import { AnimatePresence } from 'framer-motion'

import { Label, Wrap } from './styled'

import { LoveIcon } from 'src/components/Icons/Love'
import { ActionAnswer } from 'src/api/quizzes/types'
import { NopeIcon, MehIcon, LikeIcon, SkipIcon } from 'src/components/Icons'

interface EmotionFaceProps {
  emotion?: ActionAnswer
}

const FaceIcon: React.FC<EmotionFaceProps> = ({ emotion }) => {
  switch (emotion) {
    case ActionAnswer.up:
      return <LoveIcon />
    case ActionAnswer.down:
      return <NopeIcon />
    case ActionAnswer.left:
      return <MehIcon />
    case ActionAnswer.right:
      return <LikeIcon />
    case ActionAnswer.skip:
      return <SkipIcon />
    default:
      return null
  }
}

const getLabel = (emotion: ActionAnswer) => {
  switch (emotion) {
    case ActionAnswer.up:
      return 'Love'
    case ActionAnswer.down:
      return 'Nope'
    case ActionAnswer.left:
      return 'Meh'
    case ActionAnswer.right:
      return 'Like'
    case ActionAnswer.skip:
      return 'Skip'
    default:
      return ''
  }
}

export const EmotionFace: React.FC<EmotionFaceProps> = ({ emotion }) => {
  const labelText = emotion ? getLabel(emotion) : null

  return (
    <AnimatePresence>
      {emotion && (
        <Wrap
          emotion={emotion}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <FaceIcon emotion={emotion} />
          {labelText && <Label>{labelText}</Label>}
        </Wrap>
      )}
    </AnimatePresence>
  )
}
